import React, { useContext, useState } from 'react';
import { ThemeContext } from '../../themes/campaignThemes';
import { Spacer } from 'shared/layout';
import { H2, MainBody } from 'shared/components';
import { postSubscriptionBlock } from 'api';
import {
	FullWidthColoredBackground,
	CampaignBlockContainer,
	CampaignButton,
} from '../../pages/CampaignPage/CampaignPage.styles';
import Link from 'next/link';
import {
	CampaignInput,
	CampaignLink,
	ButtonAndLinkContainer,
} from './CampaignSubscriptionBlock.styles';

const CampaignSubscriptionBlock = ({
	Heading = '',
	ButtonText = '',
	GdprLink = {},
	TopicId = '',
	Preamble = '',
	ThankYouMessage = '',
}) => {
	const theme = useContext(ThemeContext);
	const [email, setEmail] = useState('');
	const [isSubscribed, setIsSubscribed] = useState(false);

	const handleSubscribe = async () => {
		if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
			alert('E-postadressen är inte giltig.');
			return;
		}

		var selectedCategories = TopicId;
		try {
			const response = await postSubscriptionBlock({
				email,
				selectedCategories,
			});
			if (response.Success) {
				setEmail('');
				setIsSubscribed(true);
			}
		} catch (error) {
			console.error('Error subscribing:', error);
			alert('Något gick fel. Försök igen senare.');
			return;
		}
	};

	return (
		<FullWidthColoredBackground $color={theme.color[2]}>
			<CampaignBlockContainer $theme={theme}>
				{!isSubscribed ? (
					<>
						{!!Heading && (
							<H2
								word-break={{ base: 'break-word', md: 'unset' }}
								color={theme.color[5]}
							>
								{Heading}
							</H2>
						)}

						{!!Preamble && (
							<>
								<Spacer spacing={{ base: 2, md: 4 }}></Spacer>
								<MainBody
									as="p"
									color={theme.color[5]}
									fontWeight={'bold'}
								>
									{Preamble}
								</MainBody>
							</>
						)}

						<Spacer>
							<CampaignInput
								$theme={theme}
								type="email"
								value={email}
								placeholder={'Mejladress'}
								onChange={(e) => {
									setEmail(e.target.value);
								}}
							/>
						</Spacer>

						{!!ButtonText && (
							<ButtonAndLinkContainer>
								<Spacer>
									<CampaignButton
										onClick={() => handleSubscribe()}
										$theme={theme}
										$backgroundColor={theme.color[5]}
										$textColor={theme.color.white}
										as="button"
									>
										{ButtonText}
									</CampaignButton>
								</Spacer>
								{!!GdprLink && (
									<Spacer
										style={{
											color: theme.color[5],
											fontSize: '18px',
											fontWeight: 'bold',
										}}
									>
										Vi behandlar dina kontaktuppgifter med
										stöd av ett berättigat intresse.{' '}
										<Link href={GdprLink?.Url} passHref>
											<CampaignLink>
												Läs mer om vår hantering här.
											</CampaignLink>
										</Link>
									</Spacer>
								)}
							</ButtonAndLinkContainer>
						)}
					</>
				) : (
					<>
						<H2
							word-break={{ base: 'break-word', md: 'unset' }}
							color={theme.color[1]}
						>
							Tack!
						</H2>
						<Spacer spacing={{ base: 2, md: 4 }}></Spacer>
						<MainBody as="p" color={theme.color[1]}>
							{ThankYouMessage}
						</MainBody>
					</>
				)}
			</CampaignBlockContainer>
		</FullWidthColoredBackground>
	);
};

export default CampaignSubscriptionBlock;
